import { StructureColumn } from "./report-engine-script-structure-column";

export class StructureArgument{
	columns:StructureColumn[] = [];

	public constructor(data?:any){
		if (!data) return;
		this.columns = ((data.columns as any[]) || []).map((d:any)=>new StructureColumn(d));
	}

	public getJSON(){
		return{
			columns: this.columns.map(c=>c.getJSON())
		};
	}
}